import { defaultAverageLineHeight } from '../filter/defaultValues'

export const useState = (): CruiseListState => {
  return {
    selectedEntryId: '',
    listItemHeight: [],
    averageLineHeight: defaultAverageLineHeight
  }
}

export interface CruiseListState {
  selectedEntryId: string
  listItemHeight: number[]
  averageLineHeight: number
}